export default __webpack_public_path__ + "static/media/investigacion.fa15ca7a.png";